import React, { useState, useCallback, useEffect } from "react";
import { Container } from "reactstrap";
import Redes from "./Redes";
import Moedas from "./Moedas";
import { toast } from "react-toastify";
import { APIClient } from "../../../helpers/api_helper";

const apiClient = new APIClient();

const RedesMoedas = () => {
  const [redes, setRedes] = useState(null);
  const [loading, setLoading] = useState(false);
  document.title = "Envio Semanal | Painel Fort Exchange";

  const fetchRedes = useCallback(async () => {
    setLoading(true);
    const response = await apiClient.get("/rede");
    setLoading(false);

    if (response.sucesso) {
      return response.dados;
      } else {
        toast.error(response.mensagem);
        console.log(response);
        return [];
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const retorno = await fetchRedes();
      setRedes(retorno);
    };

    if (!redes) fetchData();
  }, [redes, fetchRedes]);

  return (
    <React.Fragment>
      <Container fluid>
        <Redes
          redes={redes}
          fetchRedes={fetchRedes}
          setRedes={setRedes}
          loading={loading}
        />
        <Moedas redes={redes} />
      </Container>
    </React.Fragment>
  );
};

export default RedesMoedas;
